export const EMAILS_DIMENSIONS_WHITE_LIST = [
  'attributed',
  'origin',
  'last_attributed_touch_data_tilde_creative_id',
  'last_attributed_touch_data_tilde_tune_publisher_id',
  'last_attributed_touch_data_dollar_marketing_title',
  'last_attributed_touch_data_tilde_content_id',
  'last_attributed_touch_data_tilde_campaign',
  'last_attributed_touch_data_tilde_channel',
  'last_attributed_touch_data_tilde_feature',
  'last_attributed_touch_data_tilde_stage',
  'last_attributed_touch_data_tilde_tags',
  'last_attributed_touch_data_tilde_agency_id',
  'last_attributed_touch_data_tilde_agency',
  'last_attributed_touch_data_tilde_keyword_id',
  'user_data_platform',
  'user_data_environment',
  'user_data_geo_country_code',
  'user_data_os',
  'user_data_os_version',
  'user_data_app_store',
  'user_data_cpp_level',
  'deep_linked',
] as const;
